import * as shop from './types';

const getters = {
  [shop.SHOPS]: state => state.shops,
  [shop.SHOP]: state => state.shop,
  [shop.SHOP_COUNT]: state => state.shops.totalElements,
  [shop.SHOP_PRIOR_CONSENT]: state => state.shopPriorConsent,
  [shop.SHOP_VOUCHERS_USE_RESULT]: state => state.vouchersUseResult,
  [shop.SHOP_VOUCHERS]: state => state.shopVouchers,
};

export default getters;
